// extracted by mini-css-extract-plugin
module.exports = {"multiselect":"ChooseDebtorModal_multiselect_3KAbr","add-debtor":"ChooseDebtorModal_add-debtor_2D-rZ","addDebtor":"ChooseDebtorModal_add-debtor_2D-rZ"};